import { ISorter, ISorterConfig, ISorterExpression, SorterConfig } from "pbc.types";

export interface IIchQuerySorter extends ISorter {
}

export const IchQuerySorterConfig: ISorterConfig = [
];
